import { Button, InputCheckbox } from "@sellar-io/components";
import { useState } from "react";

import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { useBusinessAcceptTerms } from "../../../hooks/api/v2/business/useBusinessAcceptTerms";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { TermsAndConditionsCopy } from "./TermsAndConditions";

export const TermsAndConditionsDialog = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: (accepted: boolean) => void;
}) => {
  const [accepted, setAccepted] = useState(false);

  const { business: userBusiness } = useSellarCurrentBusiness();

  const businessId = userBusiness?.id;

  if (!businessId) throw new Error("Cannot find business");

  const businessAcceptTermsMutation = useBusinessAcceptTerms(businessId);

  return (
    <Dialog
      active={active}
      onDismiss={() => onDismiss(false)}
      className="max-w-[800px]"
    >
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => onDismiss(false)}
        className={"relative z-10 pb-0"}
        title="Terms & conditions"
      />
      <DialogContent>
        <TermsAndConditionsCopy supplierName={userBusiness.name} />
      </DialogContent>
      <DialogCTA>
        <div className="flex w-full flex-col justify-between gap-4">
          <div className="flex items-center gap-2">
            <InputCheckbox
              className="flex-none"
              onChange={(e) => setAccepted(e.target.checked)}
            />
            I agree to the terms and conditions and am legally authorised to do
            so on behalf of {userBusiness.name}.
          </div>
          <Button
            className="flex-none"
            onClick={() => {
              businessAcceptTermsMutation.mutate(undefined, {
                onError: () => {
                  setAccepted(false);
                  onDismiss(false);
                },
                onSuccess: () => onDismiss(true),
              });
            }}
            disabled={!accepted}
            loading={businessAcceptTermsMutation.isPending}
          >
            Confirm agreement
          </Button>
        </div>
      </DialogCTA>
    </Dialog>
  );
};
